'use client';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { SectLabel, SectH2 } from '@/components/landing/v4-shared';
import { AI_BUSINESS_PAGE_COPY } from '@/lib/marketing/messaging-bank';

export function AIBusinessPageFaq() {
  const section = AI_BUSINESS_PAGE_COPY.sections.find((s) => s.id === 'faqs');
  const faqs = AI_BUSINESS_PAGE_COPY.faqs ?? [];
  if (!section) return null;
  return (
    <section className="py-28 md:py-36 relative">
      <div className="v4-aibp-section-rule absolute top-0 inset-x-0" aria-hidden="true" />
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-14">
          <div className="mb-5 flex justify-center">
            <SectLabel color="var(--amber-glow)">{section.eyebrow}</SectLabel>
          </div>
          <SectH2 style={{ margin: '0 auto', textAlign: 'center', maxWidth: '24ch' }}>
            {section.heading}
          </SectH2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((item, i) => (
            <AccordionItem
              key={item.q}
              value={`v4-aibp-faq-${i}`}
              style={{ borderBottom: '1px solid var(--hair-2)' }}
            >
              <AccordionTrigger
                className="text-left hover:no-underline"
                style={{
                  fontFamily: 'var(--font-geist-sans)',
                  fontSize: '17px',
                  color: 'var(--paper)',
                  fontWeight: 500,
                  paddingTop: '20px',
                  paddingBottom: '20px',
                }}
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent
                style={{
                  fontFamily: 'var(--font-geist-sans)',
                  fontSize: '15px',
                  lineHeight: 1.65,
                  color: 'var(--dim)',
                  paddingBottom: '20px',
                }}
              >
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
